import { render, staticRenderFns } from "./PmauPublicHearingContributions.vue?vue&type=template&id=d4aa696e&"
import script from "./PmauPublicHearingContributions.vue?vue&type=script&lang=js&"
export * from "./PmauPublicHearingContributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports